module.exports = __webpack_public_path__ + "static/media/elegir_metodo_rut_serial_SMS.3e46929a.svg";